import { ApiEndpoints } from "../models/ApiEndpoints";
import { Field } from "../models/Field";
import { SearchFilterConfiguration } from "../models/SearchConfiguration";
import {
  useApiGet,
  ApiGetHook,
  ApiMutateHook,
  useApiMutate,
  ApiMethods,
} from "@skanska/vsa-client-auth";

export function useGetGlobalSearchConfiguration(): ApiGetHook<SearchFilterConfiguration> {
  return useApiGet<SearchFilterConfiguration>(ApiEndpoints.SearchFiltersGlobal);
}

export function useUpdateGlobalSearchConfiguration(): ApiMutateHook<
  void,
  SearchFilterConfiguration
> {
  return useApiMutate<void, SearchFilterConfiguration>(
    ApiEndpoints.SearchFiltersGlobal,
    ApiMethods.Post
  );
}

export function useGetFilterableFields(): ApiGetHook<Field[]> {
  return useApiGet<Field[]>(
    ApiEndpoints.SearchFiltersFields,
    null,
    "search-fields"
  );
}
